import React, { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import InstitutionalLogosForm from './InstitutionalLogosForm';

const InstitutionalLogosManager = ({ sectionId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null); 

  const fetchItems = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get(`/admin/sections/${sectionId}`);
      setItems(res.data.data.items || []);
    } catch (err) {
      console.error("Erro ao carregar parceiros:", err);
    } finally {
      setLoading(false);
    }
  }, [sectionId]);

  useEffect(() => {
    if (sectionId) fetchItems();
  }, [sectionId, fetchItems]);

  const handleDelete = async (itemId) => {
    if (window.confirm("Tem certeza que deseja remover este parceiro? O carrossel será reordenado automaticamente.")) {
      try {
        setLoading(true);
        // Reaproveitamos a rota genérica de exclusão de itens
        await api.delete(`/admin/timeline-items/${itemId}`);
        fetchItems(); 
      } catch (err) {
        console.error("Erro ao deletar parceiro:", err);
        alert("Erro ao deletar parceiro.");
        setLoading(false);
      }
    }
  };

  if (showForm) {
    return (
      <InstitutionalLogosForm
        sectionId={sectionId} 
        itemToEdit={editingItem}
        onSuccess={() => {
          setShowForm(false);
          setEditingItem(null);
          fetchItems();
        }} 
        onCancel={() => {
            setShowForm(false);
            setEditingItem(null);
        }}
      />
    );
  }

  if (loading) return <div className="text-center p-3">Carregando parceiros...</div>;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="fw-bold mb-0">Parceiros Cadastrados</h6>
        <button className="btn btn-sm btn-success" onClick={() => setShowForm(true)}>
          <i className="bi bi-plus-lg me-1"></i> Novo Parceiro
        </button>
      </div>

      <div className="list-group">
        {items.length === 0 ? (
          <div className="list-group-item text-center text-muted py-4">
            Nenhum parceiro cadastrado ainda nesta seção.
          </div>
        ) : (
          items.sort((a, b) => a.item_order - b.item_order).map(item => (
            <div key={item.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-3">
                <span className="badge bg-dark">Ordem {item.item_order}</span>
                {item.images && item.images.length > 0 && (
                  <img src={`${process.env.REACT_APP_BACKEND_URL || 'http://localhost:3030'}${item.images[0].image_url}`} alt="Logo" style={{ height: '30px', width: '30px', objectFit: 'contain' }} />
                )}
                <strong>{item.title}</strong>
              </div>
              <div className="btn-group">
                <button 
                    className="btn btn-sm btn-outline-primary" 
                    title="Editar"
                    onClick={() => {
                        setEditingItem(item);
                        setShowForm(true);
                    }}>
                    <i className="bi bi-pencil"></i>
                </button>
                <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(item.id)} title="Excluir">
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default InstitutionalLogosManager;
